import { all } from 'redux-saga/effects';

import paidJobSaga from './paidJobSaga';

export default function* rootSaga() {
  yield all([
    paidJobSaga(),
    // Add more sagas here just like paidJobSaga
  ]);
}
